import { View, Text, StyleSheet } from "react-native";
import SimplePress from "./SimplePress";
//import MaterialIcons from "react-native-vector-icons/MaterialIcons";
import { MaterialIcons } from "./VectorIcons";
import { checkPassword } from "../context/helper";

const PWIcon = (props) => {
  const colors = props.style?props.style.passwordStrengthColors:undefined;

  switch (props.pwStrength) {
    case 3:
      return (
        <MaterialIcons
          name="sentiment-satisfied-alt"
          size={50}
          color={colors?colors.strongColor:"#00b400"}
          style={props.style}
        />
      );
    case 2:
      return (
        <MaterialIcons
          name="sentiment-neutral"
          size={50}
          color={colors?colors.mediumColor:"#b4b400"}
          style={props.style}
        />
      );
    case 1:
      return (
        <MaterialIcons
          name="sentiment-very-dissatisfied"
          size={50}
          color={colors?colors.weakColor:"#b40000"}
          style={props.style}
        />
      );
    default:
      return (
        <MaterialIcons
          name="sentiment-very-dissatisfied"
          size={50}
          color={colors?colors.defaultColor:"#808080"}
          style={props.style}
        />
      );
  }
};
const PWText = (props) => {
  const colors = props.style?props.style.passwordStrengthColors:undefined;
  switch (props.pwStrength) {
    case 3:
      return (
        <Text style={{ color: colors?colors.strongColor:"#00b400", fontSize: 20 }}>starkes Kennwort</Text>
      );
    case 2:
      return (
        <Text style={{ color: colors?colors.mediumColor:"#b4b400", fontSize: 20 }}>
          mittleres Kennwort
        </Text>
      );
    case 1:
      return (
        <Text style={{ color: colors?colors.weakColor:"#b40000", fontSize: 20 }}>
          schwaches Kennwort
        </Text>
      );
    default:
      return (
        <Text style={{ color: colors?colors.defaultColor:"#808080", fontSize: 20 }}>kein Kennwort</Text>
      );
  }
};

const PasswordCheck = (props) => {

  const mystyle =
    props.style ? (Array.isArray(props.style) ? Object.assign({}, ...props.style) : props.style):undefined;

  const strength = checkPassword(props.password);

  return (
    <View style={props.style}>
      <View style={styles.mainContainer}>
        <PWIcon pwStrength={strength} style={{ marginRight: 10, passwordStrengthColors: mystyle?mystyle.passwordStrengthColors:undefined }} />
        <PWText pwStrength={strength} style={{ passwordStrengthColors: mystyle?mystyle.passwordStrengthColors:undefined }}/>
      </View>
      <Text style={{color: mystyle?mystyle.color:undefined}}>
        Das Kennwort muss mindestes 8 Zeichen lang sein und jeweils wenigstens
        einen Kleinbuchstaben, einen Großbuchstaben, und ein Sonderzeichen
        enthalten. Wenn zusätzlich eine Ziffer vorhanden ist, genügt auch eine
        Kennwortlänge von 6 Zeichen.
      </Text>
    </View>
  );
};
// Feather frown, smile, meh
// Fontisto frowning, neutral, smiling
// MaterialIcons sentiment-very-dissatisfied, sentiment-neutral, sentiment-satisfied-alt

export default PasswordCheck;

const styles = StyleSheet.create({
  mainContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 5,
  },
});
